import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Add from '@mui/icons-material/Add';
import PageHeader from '../../../Components/PageHeader';
import TablePeo from '../../../Components/TablePeo';
import { useApiGet } from '../../../utils/httpClientTs';
import { listItems } from '../../../endpoints/chapterSupplies';

const headCells = [
  { id: 'name', firstCell: true, label: 'Name', width: '30%' },
  { id: 'item_status_name', label: 'Status', width: '15%' },
  { id: 'sku', label: 'SKU', width: '15%' },
  { id: 'quantity_on_hand', label: 'On hand', width: '12%' },
  { id: 'created_at', label: 'Created', width: '28%' },
];

export default function ItemList() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');
  const [orderBy, setOrderBy] = useState('created_at');

  const limit = rowsPerPage;
  const offset = page * rowsPerPage;

  const { data, isFetching } = useApiGet(
    ['chapter-supplies-items', limit, offset],
    () => listItems({ limit, offset }),
    { enabled: true, retry: 1 }
  );

  const items = data?.items ?? [];
  const handleRowClick = (_event: React.MouseEvent, rowId: string | number) => {
    navigate(`/chapter-supplies-management/items/${rowId}`);
  };

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title="Items"
          leftDom={undefined}
          rightDom={
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() =>
                navigate('/chapter-supplies-management/items/create')
              }
            >
              Add item
            </Button>
          }
          subtitle={undefined}
        />
      </Grid>
      <TablePeo
        data={items}
        isFetching={isFetching}
        headCells={headCells}
        handleRowClick={handleRowClick}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        emptyMessage="No items yet. Create one to get started."
      />
    </Grid>
  );
}
